'use strict';
var optimizeCall = require('./optimizeCall');
var envHelper = require('./envHelper');

var optimizeMouseMoveCall = optimizeCall();
document.body.addEventListener('mousemove', optimizeMouseMoveCall.call);

var optimizedTouchMoveCall = optimizeCall();
document.body.addEventListener('touchmove', optimizedTouchMoveCall.call);

function dragDelegatePC(onMove, onEnd) {
  var startPosition;
  var delta;
  var isMoving = false;
  var onMoveProxy = function (e) {
    if (!startPosition) {
      startPosition = {
        pageX: e.pageX,
        pageY: e.pageY
      };
    }
    delta = {
      x: e.pageX - startPosition.pageX,
      y: e.pageY - startPosition.pageY
    };
    if (!isMoving) {
      if (Math.abs(delta.x) >= 5 || Math.abs(delta.y) >= 5) {
        isMoving = true;
      }
    }
    if (isMoving) {
      onMove(e, delta);
    }
  };
  var onEndProxy = function (e) {
    document.body.removeEventListener('mouseup', onEndProxy);
    optimizeMouseMoveCall.remove(onMoveProxy);
    onEnd(e, delta, isMoving);
  };
  document.body.addEventListener('mouseup', onEndProxy);
  optimizeMouseMoveCall.add(onMoveProxy);

}

function dragDelegateMobile(onMove, onEnd) {
  var startPosition;
  var delta;
  var isMoving = false;
  var onMoveProxy = function (e) {
    var touch = e.touches[0];
    if (!startPosition) {
      startPosition = {
        pageX: touch.pageX,
        pageY: touch.pageY
      };
    }
    delta = {
      x: touch.pageX - startPosition.pageX,
      y: touch.pageY - startPosition.pageY
    };
    if (!isMoving) {
      if (Math.abs(delta.x) >= 5 || Math.abs(delta.y) >= 5) {
        isMoving = true;
      }
    }
    if (isMoving) {
      onMove(e, delta);
    }
  };
  var onEndProxy = function (e) {
    document.body.removeEventListener('mouseup', onEndProxy);
    optimizedTouchMoveCall.remove(onMoveProxy);
    onEnd(e, delta, isMoving);
  };
  document.body.addEventListener('mouseup', onEndProxy);

  document.body.addEventListener('touchend', onEndProxy);
  optimizedTouchMoveCall.add(onMoveProxy);
}

var dragDelegate = envHelper.isMobileDevice() ? dragDelegateMobile : dragDelegatePC;

module.exports = {
  dragDelegate: dragDelegate,
  onMove: function (cb) {
    optimizeMouseMoveCall.add(cb);
  },
  offMove: function (cb) {
    optimizeMouseMoveCall.remove(cb);
  }
};



// WEBPACK FOOTER //
// ./src/helper/mouseHelper.js